<template>
  <v-navigation-drawer
    v-if="isLoggedIn && activeFilterSet && activeFilterSet !== 'telegram' && activeFilterSet !== 'dzen'"
    v-model="drawer"
    :rail="!panelVisible"
    location="right"
    permanent
    @click="expandPanel"
  >
    <!-- Expanded state -->
    <template v-if="panelVisible">
      <v-card-title class="pa-3">
        <span>Фильтры</span>
      </v-card-title>
      <v-divider></v-divider>
      
      <v-card-text class="pa-3">
      
      <!-- Telegram filters -->
      <div v-if="activeFilterSet === 'telegram'">
        <!-- Followers range -->
        <div class="mb-4">
          <div class="text-subtitle-2 mb-2">Подписчики</div>
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                :model-value="telegramFilters.followersFrom"
                @update:model-value="updateFilter('followersFrom', $event)"
                type="number"
                step="1"
                min="0"
                placeholder="от"
                variant="outlined"
                density="compact"
                hide-details
                @blur="onFilterChange"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :model-value="telegramFilters.followersTo"
                @update:model-value="updateFilter('followersTo', $event)"
                type="number"
                step="1"
                min="0"
                placeholder="до"
                variant="outlined"
                density="compact"
                hide-details
                @blur="onFilterChange"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <!-- Updated date range -->
        <div class="mb-4">
          <div class="text-subtitle-2 mb-2">Дата обновления</div>
          <v-text-field
            :model-value="telegramFilters.updatedFrom"
            @update:model-value="updateFilter('updatedFrom', $event)"
            type="date"
            label="С"
            variant="outlined"
            density="compact"
            hide-details
            class="mb-2"
            @change="onFilterChange"
          ></v-text-field>
          <v-text-field
            :model-value="telegramFilters.updatedTo"
            @update:model-value="updateFilter('updatedTo', $event)"
            type="date"
            label="По"
            variant="outlined"
            density="compact"
            hide-details
            @change="onFilterChange"
          ></v-text-field>
        </div>

        <!-- Channel title -->
        <v-text-field
          :model-value="telegramFilters.filterChannelName"
          @update:model-value="updateFilter('filterChannelName', $event)"
          label="Заголовок канала"
          variant="outlined"
          density="compact"
          hide-details
          class="mb-4"
          @blur="onFilterChange"
        ></v-text-field>

        <!-- Username -->
        <v-text-field
          :model-value="telegramFilters.filterUsername"
          @update:model-value="updateFilter('filterUsername', $event)"
          label="Имя канала"
          variant="outlined"
          density="compact"
          hide-details
          class="mb-4"
          @blur="onFilterChange"
        ></v-text-field>

        <!-- Channel ID -->
        <v-text-field
          :model-value="telegramFilters.filterChannelId"
          @update:model-value="updateFilter('filterChannelId', $event)"
          label="ID канала"
          variant="outlined"
          density="compact"
          hide-details
          class="mb-4"
          @blur="onFilterChange"
        ></v-text-field>

        <!-- Description -->
        <v-text-field
          :model-value="telegramFilters.filterDescription"
          @update:model-value="updateFilter('filterDescription', $event)"
          label="Описание"
          variant="outlined"
          density="compact"
          hide-details
          class="mb-4"
          @blur="onFilterChange"
        ></v-text-field>

        <!-- Type -->
        <v-select
          :model-value="telegramFilters.filterType"
          @update:model-value="updateFilter('filterType', $event)"
          :items="typeOptions"
          item-title="text"
          item-value="value"
          label="Вид"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
        ></v-select>

        <!-- Access type -->
        <v-select
          :model-value="telegramFilters.filterAccessType"
          @update:model-value="updateFilter('filterAccessType', $event)"
          :items="accessTypeOptions"
          item-title="text"
          item-value="value"
          label="Тип доступа"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
        ></v-select>

        <!-- Country -->
        <v-select
          :model-value="telegramFilters.filterCountry"
          @update:model-value="updateFilter('filterCountry', $event)"
          :items="countries"
          item-title="option"
          item-value="value"
          label="Страна"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
        ></v-select>

        <!-- Section -->
        <v-select
          :model-value="telegramFilters.filterSection"
          @update:model-value="updateFilter('filterSection', $event)"
          :items="sections"
          item-title="option"
          item-value="value"
          label="Раздел"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
        ></v-select>

        <!-- Monitoring -->
        <v-select
          :model-value="telegramFilters.filterIsMonitoring"
          @update:model-value="updateFilter('filterIsMonitoring', $event)"
          :items="monitoringOptions"
          item-title="text"
          item-value="value"
          label="Отслеживается"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
        ></v-select>

        <!-- Tags -->
        <v-autocomplete
          :model-value="telegramFilters.filterTags"
          @update:model-value="updateFilter('filterTags', $event)"
          :items="availableTags"
          item-title="name"
          item-value="id"
          label="Теги"
          multiple
          chips
          closable-chips
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mb-4"
          @update:search="searchAvailableTags"
          return-object
          ref="tagFilterAutocomplete"
        >
          <template #chip="{ props, item }">
            <v-chip
              v-bind="props"
              :text="item.raw.name"
              closable
              size="small"
              color="primary"
            />
          </template>
        </v-autocomplete>

        <!-- Status -->
        <v-select
          :model-value="telegramFilters.filterStatus"
          @update:model-value="updateFilter('filterStatus', $event)"
          :items="statusOptions"
          item-title="text"
          item-value="value"
          label="Статус"
          variant="outlined"
          density="compact"
          hide-details
          clearable
        ></v-select>
      </div>

      <!-- Results filters (placeholder for future) -->
      <div v-else-if="activeFilterSet === 'results'">
        <!-- Results specific filters will go here -->
      </div>
      </v-card-text>
    </template>
    
    <!-- Collapsed state -->
    <template v-else>
      <div class="d-flex justify-center">
        <v-btn
          variant="text"
          icon
          @click.stop="togglePanel"
          class="ma-2"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import apiClient from '@/apiClient';

export default {
  name: 'FilterPanel',
  data() {
    return {
      drawer: true,
      availableTags: [],
      countries: [],
      sections: [],
      // Options
      typeOptions: [
        { text: 'Все', value: '' },
        { text: 'Канал', value: 'channel' },
        { text: 'Чат', value: 'chat' }
      ],
      accessTypeOptions: [
        { text: 'Все', value: '' },
        { text: 'Публичный web', value: 'PUBLIC_WEB_CHANNEL' },
        { text: 'Публичный', value: 'PUBLIC_CHANNEL' },
        { text: 'Приватный чат', value: 'PRIVATE_CHAT' },
        { text: 'Приватный канал', value: 'PRIVATE_CHANNEL' },
        { text: 'Неизвестный', value: 'UNKNOWN' }
      ],
      monitoringOptions: [
        { text: 'Все', value: '' },
        { text: 'Да', value: '1' },
        { text: 'Нет', value: '0' }
      ],
      statusOptions: [
        { text: 'Все', value: '' },
        { text: 'Активный', value: 'active' },
        { text: 'Ожидает', value: 'pending' },
        { text: 'Удалён', value: 'deleted' },
        { text: 'Заблокирован', value: 'blocked' }
      ]
    };
  },
  computed: {
    ...mapState(['isLoggedIn']),
    ...mapState('filters', ['panelVisible', 'activeFilterSet']),
    ...mapGetters('filters', ['telegramFilters', 'resultsFilters']),
    
    totalItems() {
      if (this.activeFilterSet === 'telegram') {
        return this.telegramFilters.totalItems;
      } else if (this.activeFilterSet === 'results') {
        return 0; // Will be implemented
      }
      return 0;
    }
  },
  methods: {
    ...mapActions('filters', [
      'togglePanel',
      'showPanel',
      'updateTelegramFilter',
      'saveTelegramFiltersToCache'
    ]),
    
    expandPanel() {
      if (!this.panelVisible) {
        this.showPanel();
      }
    },
    
    updateFilter(field, value) {
      if (this.activeFilterSet === 'telegram') {
        // Convert number inputs
        if (field === 'followersFrom' || field === 'followersTo') {
          value = value ? Number(value) : null;
        }
        this.updateTelegramFilter({ field, value });
      }
    },
    
    onFilterChange() {
      // Just save to cache, components will react via watchers
      this.saveTelegramFiltersToCache();
    },
    
    async searchAvailableTags(query) {
      if (!query) {
        this.availableTags = [];
        return;
      }
      try {
        const resp = await apiClient.get('/tags', { params: { q: query } });
        this.availableTags = resp.data.map(t => ({ id: t.id, name: t.name }));
      } catch (e) {
        this.availableTags = [];
      }
    },
    
    async loadReferenceData() {
      // Only load reference data for telegram filters
      if (this.activeFilterSet !== 'telegram') {
        return;
      }

      try {
        const [resCountries, resSections] = await Promise.all([
          apiClient.get('/reference/geolocations/countries'),
          apiClient.get('/v2/platform-sources/sections')
        ]);
        this.countries = resCountries.data;
        this.sections = resSections.data;
      } catch (error) {
        console.error('Error loading reference data:', error);
      }
    }
  },
  watch: {
    activeFilterSet(newValue) {
      if (newValue === 'telegram' && this.countries.length === 0) {
        this.loadReferenceData();
      }
    }
  },
  async mounted() {
    if (this.activeFilterSet === 'telegram') {
      await this.loadReferenceData();
    }
  }
};
</script>

<style scoped>
/* Custom styles for filter panel */
.v-navigation-drawer {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
</style>